import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { FernMark } from '@/components/generals/fern-mark'

interface LogoProps {
    tone?: 'default' | 'light'
    className?: string
}

export const Logo: FC<LogoProps> = ({ tone = 'default', className }): ReactNode => {
    const isLight = tone === 'light'

    return (
        <Link
            href='/'
            className={cn(
                'inline-flex items-center gap-2.5 rounded-xl focus-visible:outline-2 focus-visible:outline-offset-4',
                isLight ? 'focus-visible:outline-honey' : 'focus-visible:outline-plum',
                className
            )}
        >
            <FernMark className={cn('h-10 w-auto shrink-0', isLight ? 'text-honey' : 'text-plum')} />

            <span className='flex flex-col'>
                <span className={cn('font-heading text-[1.7rem] leading-none', isLight ? 'text-white' : 'text-plum')}>
                    Fernwell
                </span>

                <span className={cn('mt-1.5 pl-0.5 text-[0.62rem] font-medium uppercase leading-none tracking-[0.25em]', isLight ? 'text-white/80' : 'text-espresso-soft')}>
                    Counseling
                </span>
            </span>
        </Link>
    )
}
